'use client';

import { datadogRum } from '@datadog/browser-rum';

const ENABLED_ENVS = ['product', 'staging', 'dev'];

const env = process.env.ENVIRONMENT;
// GitHub environment secrets → docker build-arg → 빌드타임 인라인.
// 값이 주입되지 않은 빌드(로컬)에서는 초기화를 건너뛴다.
const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
// source map 업로드(--release-version)와 동일 값이어야 에러 스택 매칭이 된다
const version = process.env.NEXT_PUBLIC_DATADOG_VERSION;

/**
 * Datadog RUM 초기화 (앱: fastfive-consumer-web).
 *
 * useEffect 가 아닌 모듈 스코프에서 초기화해 hydration 이전의 초기 로딩
 * 구간(리소스 타이밍, 초기 에러)까지 수집한다. 클라이언트 컴포넌트 모듈은
 * 서버에서도 평가되므로 window 가드가 필수.
 */
if (
  typeof window !== 'undefined' &&
  env !== undefined &&
  ENABLED_ENVS.includes(env) &&
  applicationId !== undefined &&
  applicationId !== '' &&
  clientToken !== undefined &&
  clientToken !== '' &&
  !datadogRum.getInitConfiguration()
) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'fastfive-consumer-web',
    env,
    version,
    sessionSampleRate: 100,
    // Session Replay 는 세션당 별도 과금이라 20% 로 시작 (필요 시 상향)
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

export function DatadogRum() {
  return null;
}
